import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading, hasRole } = useAuth();
  if (loading)
    return (
      <div className="h-screen grid place-items-center bg-zinc-100">
        <div className="label-mini">Loading…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !hasRole(...roles))
    return (
      <div className="p-8">
        <div className="card-sharp p-6 max-w-md">
          <div className="label-mini text-red-700">Access Denied</div>
          <h2 className="text-xl font-bold mt-1">You don't have permission to view this page.</h2>
          <p className="text-sm text-zinc-500 mt-2">Required role(s): {roles.join(", ")}.</p>
        </div>
      </div>
    );
  return children;
}
